import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { AtecoCodeInterface } from '@app/interface/ateco-code';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AtecoCodeApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllAtecoCodes<T = AtecoCodeInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/ateco-code/`;
    // console.log(path);
    return this.getRecursivePage<T>(path, params);
  }

  public getAtecoCodeDetails<T = AtecoCodeInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
    ateco_code_id: number | null,
  ): Observable<T> {
    const path = `api/${organization_id}/ateco-code/${ateco_code_id}/`;

    // Add the ID to params if provided
    // if (ateco_code_id) {
    //   params['id'] = ateco_code_id.toString();
    // }

    return this.get<T>(path, params);
  }
}
